import axios from "axios";
import { Constants } from '../utils/Constants';

export function login(fei_cpf, password) {
	return axios.post(`${Constants.baseUrl}/auth`, { fei_cpf, password });
}
